import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import InputSearch from "../../component/InputSearch";
import { AppContext } from "../../appContext/AppContext";
import { KEY } from "../../component/autocompleteOct/models";
import { TableCustom } from "../../component/table/table-custom/TableCustom";
import { CODE, DEFAULT_PAGE_INDEX, SELECTION_MODE } from "../../utils/Constant";
import { TablePagination } from "../../component/table/components/TablePagination";
import { handlePagesChange, handleRowsPerPageChange, rowsForPage } from "../../utils/PageUtils";
import { columnDM } from "../const/Columns";
import { searchList, deleteDanhMuc, importDanhMuc, downloadSampleImportDanhMuc, searchListDM } from "../DanhMucServices";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import LabelRequired from "../../component/LabelRequired";
import AutocompleteObjectV2 from '../../component/AutocompleteObjectV2';
import DialogThemDanhMuc from "./DialogThemDanhMuc";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";
import { ConfirmDialog } from "../../component/ConfirmDialog";
import { generateForm, generateInitValues } from "../../utils/AppFunction";
import { localStorageItem } from "../../utils/LocalStorage";
import { ColumnConfig } from "../../component/table/table-generate/ColumnConfig";
import { generateColumns } from "../../component/table/table-generate/GenerateColumns";
import TextField from "../../component/TextField";
import { formatDateToDDMMYYYY } from "../../utils/FormatUtils";
import { columnNamesType, OctTablePagination } from "@oceantech/oceantech-ui";
import { COMPONENT_TYPE, PROPERTIES_VALUE } from "../../component/generate-form/GenerateFormConfig";
import "../DanhMuc.scss"
import OctTableCollapse from "../../component/table/table-collapse-custom/OctTableCollapse";
import { log } from "node:util";

interface TableDSVatTuProps { }

const TableDSVatTu: React.FC<TableDSVatTuProps> = (props) => {
    const dataUser = localStorageItem.get("current-user") || {};
    const DEFAULT_ROWS_PER_PAGE = 100;
    const { setIsLoading } = useContext(AppContext);
    const [dsVatTu, setDsVatTu] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState<number>(DEFAULT_ROWS_PER_PAGE);
    const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
    const [listDM, setListDM] = useState<any[]>();
    const [openDialogConfirmDelete, setOpenDialogConfirmDelete] = useState<boolean>(false);
    const [dataEdit, setDataEdit] = useState<any>();
    const [keyword, setKeyWord] = useState<any>();
    const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
    const [columns, setColumns] = useState<any>(columnDM["NCC"]);
    const [openDialogThemMoi, setOpenDialogThemMoi] = useState<any>(false);
    const [initValues, setInitValues] = useState<any>({});
    const [configTable, setConfigTable] = useState<any>({
        totalPages: 0,
        totalElements: 0,
        numberOfElements: 0,
    });
    const [searchObj, setSearchObj] = useState<any>({
        pageSize: 1000,
        pageIndex: 1,
    });
    const handlerSearchKeyWorld = () => {
        setPage(DEFAULT_PAGE_INDEX);
        setRowsPerPage(DEFAULT_ROWS_PER_PAGE);
        updatePageData()
    }
    // const COLUMNS = {
    //     formdanhmucncc: columnDM['NCC'],
    //     formdanhmuchangsx: columnDM['HSX'],
    //     formdanhmucnuocsx: columnDM['NSX'],
    //     dmthemdonvitinh: columnDM['DVT'],
    //     dmthemduongdung: columnDM['DD'],
    //     dmthemhoatchat: columnDM['HC'],
    //     danhmucgoithau: columnDM['THAU'],
    // }
    useEffect(() => {
        searchObj?.code && updateForm();
    }, [searchObj?.code]);

    const updateForm = async () => {
        try {
            const data = await generateForm(searchObj?.code, setIsLoading);
            setInitValues({
                ...generateInitValues(data),
                doCreation: new Date(),
                creator: dataUser?.sub,
            });

            const listColumns: ColumnConfig[] = extractTableComponents(data);

            // setColumns(generateColumns(listColumns));

            const _listColumns = listColumns.map((x: any, index) => {
                if (index === 1) {
                    return {
                        ...x,
                        cellStyle: {
                            ...x?.cellStyle,
                            minWidth: x?.cellStyle?.minWidth || 260
                        },
                        isCollapse: true,
                    }
                } else {
                    return x
                }
            })
            setColumns(_listColumns);
            setListJsonGenerate(data || []);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    };

    const extractTableComponents = (data: any): any[] => {
        let result: columnNamesType[] = [
            {
                name: "STT",
                field: "stt",
                render: (row: any, index: number, stt: number) => <span>{index + 1}</span>,
            },
        ];

        const traverse = (components: any[]) => {
            components.forEach(component => {
                if (component.tableView === true) {
                    result.push({
                        field: component?.type === "select" ? `${component?.key + "Name"}` : component?.key,
                        name: component?.label,
                        headerStyle: {
                            minWidth: "150px",
                        },
                        cellStyle: {
                            minWidth: component?.properties?.minWidth,
                            justifyContent: component?.type === COMPONENT_TYPE.DATETIME && "center",
                        },
                        ...(component?.type === COMPONENT_TYPE.DATETIME && {
                            render: (row: any) => {
                                return formatDateToDDMMYYYY(row?.[component?.key]) ?? ""
                            },
                        }),
                        ...(component?.properties?.datatypeId === PROPERTIES_VALUE.DATATYPE_ID.COMPLEX && {
                            render: (row: any) => row?.[component?.key]?.[component?.properties?.displayField] ?? "",
                        })
                    }); // Chỉ lấy những component có tableView: true
                }

                if (component.components) {
                    traverse(component.components); // Duyệt vào components con
                }

                if (component.columns) {
                    component.columns.forEach((column: any) => {
                        if (column?.components) {
                            traverse(column?.components); // Duyệt tiếp vào columns
                        }
                    });
                }
            });
        };

        if (data.components) {
            traverse(data.components);
        }

        return result;
    };

    useEffect(() => {
        getListKho();
    }, [])
    const getListKho = async () => {
        try {
            setIsLoading(true);
            let { data } = await searchListDM();
            setListDM(data?.data?.content);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleCloseDialogDelete = () => {
        updatePageData();
        setDataEdit({});
        setOpenDialogConfirmDelete(false);
        setOpenDialogThemMoi(false);
    };
    const handlerClose = () => {
        setInitValues({
            ...generateInitValues(listJsonGenerate),
            doCreation: new Date(),
            creator: dataUser?.sub,
        });
        setDataEdit({});
        setOpenDialogThemMoi(false);
        updatePageData()
    }
    const handlerOpen = () => {
        if (!searchObj?.code) return toast.error('Vui lòng chọn danh mục');
        setOpenDialogThemMoi(true);
    }
    const updatePageData = async () => {
        if (!listJsonGenerate?.path) return;
        setDsVatTu([]);
        try {
            setIsLoading(true);
            const { data } = await searchList(listJsonGenerate?.path, {
                // ...searchObj,
                keyword: keyword,
                pageSize: rowsPerPage,
                pageIndex: page,
            });
            if (CODE.SUCCESS === data.code) {
                setDsVatTu(data.data?.content);
                setConfigTable({
                    totalPages: Math.ceil(data.data.pageable.totalElements / data.data.pageable.pageSize),
                    totalElements: data?.data?.pageable?.totalElements,
                })
            } else {
                toast.error('Có lỗi xảy ra, vui lòng thử lại');
            };
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // const modelIdKey = searchObj?.code as keyof typeof COLUMNS;
        if (searchObj?.code) {
            updatePageData();
            // setColumns(COLUMNS[modelIdKey])
        }
    }, [page, rowsPerPage, listJsonGenerate?.path]);

    const handleChangeSelect = (options?: any) => {
        // handlerSearchKeyWorld()
        setPage(DEFAULT_PAGE_INDEX);
        setRowsPerPage(DEFAULT_ROWS_PER_PAGE);
        setKeyWord("")
        setSearchObj({
            ...searchObj,
            code: options?.code,
            name: options?.name,
            id: options?.id,
            description: JSON.parse(options.description),
        })
    };

    const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
        setKeyWord(e.target.value)
    };

    const handleDelete = async (row: any) => {
        if (row?.isWarehouseReceipt) return toast.warning("Gói thầu đang được sử dụng,không thể xóa !");
        try {
            setIsLoading(true);
            const res = await deleteDanhMuc(listJsonGenerate?.path, row ?? dataEdit);
            if (CODE.SUCCESS === res.status) {
                toast.success("Xóa phiếu thành công");
                setDataEdit({});
                setOpenDialogConfirmDelete(false);
                updatePageData();
            }
        } catch (error: any) {
            const message = error?.message || "Có lỗi xảy ra, vui lòng thử lại";
            toast.error(message);
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const columnsActions = {
        Header: (props: any) => (
            <TableCustomHeader<any>
                tableProps={props}
                title={"Thao tác"}
                className='text-center text-light w-80px'
            />
        ),
        id: 'actions',
        Cell: ({ ...props }) => (
            <div className="d-flex justify-content-center gap-3 w-80px">
                <CustomIconButton
                    variant="edit"
                    onClick={() => {
                        setDataEdit(props.cell.row.original);
                        setOpenDialogThemMoi(true);
                    }}
                >
                    <i className="bi bi-pencil-square text-navy"></i>
                </CustomIconButton>
                {(props.cell.row.original?.color != "#28A745" && !props.cell.row.original?.isWarehouseReceipt) &&
                    <CustomIconButton
                        variant="delete"
                        onClick={() => {
                            setDataEdit(props.cell.row.original);
                            setOpenDialogConfirmDelete(true);
                        }}
                    >
                        <i className="bi bi-trash3-fill text-danger"></i>
                    </CustomIconButton>
                }
            </div>
        )
    };

    const handleSelectFileImport = async (e: any) => {
        if (!searchObj?.code) return toast.error('Vui lòng chọn danh mục');
        if (!e.target.files[0]) return;
        try {
            setIsLoading(true);
            const file = e.target.files[0];
            const { data } = await importDanhMuc(file, searchObj.code);
            if (CODE.SUCCESS === data.code) {
                updatePageData();
            } else {
                toast.error(data?.message || "Có lỗi xảy ra, vui lòng thử lại");
            }
        } catch (error) {
            toast.error("Có lỗi xảy ra, vui lòng thử lại");
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDownloadSampleImport = async () => {
        if (!searchObj?.code) return toast.error("Vui lòng chọn danh mục");
        try {
            setIsLoading(true);
            const response = await downloadSampleImportDanhMuc(searchObj.code);
            const blob = new Blob([response.data], { type: "application/xlsx" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `Sample Import ${searchObj.code}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            toast.error("Có lỗi xảy ra, vui lòng thử lại");
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleOpenDialog = () => {
        setOpenDialogThemMoi(true)
    }

    const handleEdit = (row: any) => {
        setDataEdit(row)
        handleOpenDialog()
    }

    return (
        <div className="bg-white h-100">
            <div className="flex-1 flex flex-column">
                <div className="d-flex bg-gray ">
                    <div className="spaces width-100 bg-gray radius-2">
                        <div className="flex justify-content-between bg-white spaces width-100 " >

                        </div>
                        <div className="d-flex  mt-1 flex-column spaces width-100">
                            <div className="bg-white">
                                <div className="d-flex spaces px-8 bg-white  align-items-center mb-6">
                                    <div className="d-flex spaces mt-6">
                                        <LabelRequired className="spaces min-w-80" label={"Danh mục"} />
                                    </div>
                                    <div className="d-flex">
                                        <AutocompleteObjectV2
                                            options={listDM || []}
                                            isSearchDefauilt={true}
                                            name={"WmsCode"}
                                            onChange={(options: any) => handleChangeSelect(options)}
                                            className="autocomplete-custom-renderform mt-6 pl-5 radius spaces min-w-200 h-29"
                                            isClearable={false}
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <Button className="btn-fill mt-5 ml-10 spaces min-w-90px btn btn-primary" onClick={handlerOpen}>
                                            <i className='bi bi-plus-lg text-pri fs-3'></i> Thêm
                                        </Button>
                                        {searchObj.code !== 'danhmucgoithau' && (<>
                                            <Button className="btn-fill position-relative spaces mt-5 ml-10 spaces min-w-90px btn btn-primary" >
                                                Nhập Excel
                                                <TextField
                                                    className="btn-file"
                                                    type="file"
                                                    name={`fileImport${searchObj.code}`}
                                                    onChange={(e: any) => handleSelectFileImport(e)}
                                                />
                                            </Button>
                                            <Button className="btn-fill mt-5 ml-10 spaces min-w-90px btn btn-primary" onClick={handleDownloadSampleImport}>
                                                Tải mẫu nhập Excel
                                            </Button>
                                        </>)}
                                    </div>
                                </div>
                                <div className="d-flex spaces px-8 mt-6 bg-white justify-content-between align-items-center mb-6">
                                    <div className="flex-grow-1 ">
                                        <InputSearch
                                            name="keyword"
                                            value={keyword || ''}
                                            placeholder="Tìm kiếm theo mã hoặc tên"
                                            handleChange={handleChangeSearchData}
                                            handleSearch={handlerSearchKeyWorld}
                                            handleKeyDown={(e: React.KeyboardEvent) => e.key === KEY.ENTER && handlerSearchKeyWorld()}
                                            className="spaces h-31 pr-4  radius-3"
                                        />
                                    </div>
                                </div>
                                <div className=" spaces bg-white mb-0 table-danh-muc">
                                    <OctTableCollapse
                                        data={dsVatTu}
                                        columns={columns}
                                        buttonEdit
                                        buttonDelete
                                        searchObject={searchObj}
                                        setSearchObject={setSearchObj}
                                        updateTableData={updatePageData}
                                        handleEdit={handleEdit}
                                        handleDelete={handleDelete}
                                        handleOpenDialog={handlerOpen}
                                        nameChildren="subs"
                                        isSelect
                                        noToolbar
                                        isLevel
                                        selectionMode={SELECTION_MODE.MULTI}
                                        setData={(value: any) => { }}
                                        selectData={(value: any) => { }} />

                                    <OctTablePagination
                                        handlePagesChange={handlePagesChange}
                                        handleRowsPerPageChange={handleRowsPerPageChange}
                                        rowsForPage={rowsForPage}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        setPage={(pageIndex) => {
                                            setPage(pageIndex);
                                        }}
                                        setRowsPerPage={(pageSize) => {
                                            setRowsPerPage(pageSize);
                                        }}
                                        totalPages={Number(configTable.totalPages)}
                                        totalElements={configTable.totalElements}
                                        numberOfElements={0}
                                        className="border border-0"
                                    />

                                    {/*<TableCustom<any>*/}
                                    {/*    className="spaces h-calc-vh-230"*/}
                                    {/*    data={dsVatTu}*/}
                                    {/*    columns={columns}*/}
                                    {/*    columnsActions={columnsActions}*/}
                                    {/*    verticalScroll={true}*/}
                                    {/*    selectionMode={SELECTION_MODE.SINGLE_NO_RADIO_BUTTON}*/}
                                    {/*/>*/}
                                    {/*<TablePagination*/}
                                    {/*    handlePagesChange={handlePagesChange}*/}
                                    {/*    handleRowsPerPageChange={handleRowsPerPageChange}*/}
                                    {/*    rowsPerPage={rowsPerPage}*/}
                                    {/*    rowsForPage={rowsForPage}*/}
                                    {/*    page={page}*/}
                                    {/*    setPage={setPage}*/}
                                    {/*    setRowsPerPage={setRowsPerPage}*/}
                                    {/*    totalPages={Number(configTable.totalPages)}*/}
                                    {/*    totalElements={configTable.totalElements}*/}
                                    {/*    numberOfElements={configTable.numberOfElements}*/}
                                    {/*    className="border border-0"*/}
                                    {/*/>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {openDialogThemMoi &&
                <DialogThemDanhMuc
                    dataEdit={dataEdit}
                    listJsonGenerate={listJsonGenerate}
                    onHide={() => handlerClose()}
                    item={searchObj}
                    show={openDialogThemMoi}
                    initialValues={initValues}
                    handleDownloadSampleImport={handleDownloadSampleImport}
                />
            }
            {/*{openDialogConfirmDelete && (*/}
            {/*    <ConfirmDialog*/}
            {/*        show={openDialogConfirmDelete}*/}
            {/*        onCloseClick={handleCloseDialogDelete}*/}
            {/*        onYesClick={handleDelete}*/}
            {/*        title="Xóa danh mục"*/}
            {/*        message={`Bạn chắc chắn muốn xóa danh mục: ${dataEdit.name || dataEdit.decisionNumber} ?`}*/}
            {/*        yes="Xóa"*/}
            {/*        close="Hủy"*/}
            {/*    />*/}
            {/*)}*/}
        </div>
    );
};

export default TableDSVatTu;